import React from "react";
import CodeTabBlock from "./CodeTabBlock";

const CodeTabsNotebook = () => {
  const tabName = "Notebook";
  const tabContent = {
    Python: `
    import notebooksalamode as mode  # Required library in Python
    df = datasets["New Users"]       # export_csv() accepts any valid pandas DataFrame. This
    mode.export_csv(df)              # example uses the result set from a query named "New Users".
    `,
    R: `
    df <- datasets[["New Users"]]  # export_data() accepts any valid Data Frame. This
    export_data(df)                # example uses the result set from a query named "New Users".
    `
  };
  return (
    <CodeTabBlock tabName={tabName} tabContent={tabContent}/>
  );
};

export default CodeTabsNotebook;
